module.exports = __webpack_public_path__ + "img/logo.91d9647.png";